module.exports = __webpack_public_path__ + "img/vertical_4_1_1.256fdda4.png";